module.exports = __webpack_public_path__ + "img/bild-a.1fcd6a6e.png";